module.exports = __webpack_public_path__ + "static/background1-3d26f91517a57d7ac89344c93f8ad5d8.svg";